

// qui importo i JS che ho separato per meglio 
// consentirti di gestire e controllare eventuali animazioni o comportamenti
// ogni JS ha il nome del blocco/flexiblecontent al quale si riferisce
import './site/hero.js';
import './site/marquee.js';
import './site/loadmore.js';
import './site/servizi-svg-animation.js';

window.addEventListener('scroll', function() {
  //immagini e testi entrano in opacità
  const loaded_items_opacity = document.querySelectorAll('.loaded_item_opacity')
  loaded_items_opacity.forEach((item) => {
    if(item.getBoundingClientRect().top < window.innerHeight - (item.getBoundingClientRect().height / 6)) {
      item.classList.add('loaded')
    }
  })
  // Header
	const header = document.querySelector('header')
	const scroll = document.documentElement.scrollTop || document.body.scrollTop

	if(scroll >= 100) {
		header.classList.add('compact')
	} else {
		header.classList.remove('compact')
	}
}) 

window.addEventListener('load', function() {

  //immagini e testi entrano in opacità
  const loaded_items_opacity = document.querySelectorAll('.loaded_item_opacity')
  loaded_items_opacity.forEach((item) => {
    if(item.getBoundingClientRect().top < window.innerHeight - (item.getBoundingClientRect().height / 6)) {
      item.classList.add('loaded')
    }
  })
  //mobile menu
  const toggle = document.querySelector('.menu-toggle')
  const menu = document.querySelector('.menu-modal')
  const links = document.querySelectorAll('.menu-link')

  toggle.addEventListener("click", function(){
    if(!menu.extended) {
      openMenu(menu)
    } else {
      closeMenu(menu)
    }
  })
  


// qui c'è il tuo openMenu e closeMenu per la "modale" di destra
function openMenu(el) {
  const menu = document.querySelector('.menu-modal')
  const menuToggle = document.querySelector('.menu-toggle')
  const menuLine1 = document.querySelector('.line')

  menu.classList.add('open')
  menuToggle.classList.add('active')
  menuLine1.classList.add('hide')

  el.extended = true
} 

function closeMenu(el) {
  const menu = document.querySelector('.menu-modal')
  const menuToggle = document.querySelector('.menu-toggle')
  const menuLine1 = document.querySelector('.line')

  menu.classList.remove('open')
  menuToggle.classList.remove('active')
  menuLine1.classList.remove('hide')

  el.extended = false
} 




})

